// extracted by mini-css-extract-plugin
module.exports = {"blog__content":"styles_blog__content__2HPJU"};